import React, { useCallback } from 'react';
import { ButtonTertiary } from 'components';
import { useRecoilState } from 'recoil';
import { lookupState } from 'state/atoms';

const RequestReview = () => {
  const [currentLookupState, setLookupState] = useRecoilState(lookupState);

  const setReviewRequested = useCallback(() => {
    setLookupState({
      ...currentLookupState,
      reviewRequested: true,
    });
  }, [currentLookupState, setLookupState]);

  return currentLookupState.reviewRequested ? null : (
    <ButtonTertiary onClick={setReviewRequested}>
      Request Warranty Review
    </ButtonTertiary>
  );
};

export default RequestReview;
